import type { AnswerQuestionMatchingAnswer } from '@repo/types/questions/QuestionMatching';

import { QuestionMarkedMatching } from '@/components/features/quiz/question/question-marked/question-matching';
import { QuestionBase } from '@/components/features/quiz/question/question-resolver';
import { Button } from '@/components/ui/button';
import { useQuestionMatching } from '@/hooks/questions';

import type { QuestionMatchingProps } from '.';

import { MatchingColumn } from '.';

export function QuestionMatching(questionMatchingProps: QuestionMatchingProps) {
  const { question, showMarked } = questionMatchingProps;
  const { marked, selectedLeft, selectedRight, columns, answers, isAnswerUsed, handleAnswerClick, clearAllPairs, getPairNumber, getMarkedState, exportedUserAnswer } =
    useQuestionMatching(questionMatchingProps);

  return (
    <QuestionBase content={question.content} type={question.type}>
      <div>
        <Button size={'sm'} variant="outline" onClick={clearAllPairs} disabled={answers.length === 0 || showMarked}>
          Wyczyść wszystkie pary
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:gap-6">
        <MatchingColumn
          answers={columns[0] as AnswerQuestionMatchingAnswer[]}
          selectedAnswerId={selectedLeft}
          column="left"
          isAnswerUsed={isAnswerUsed}
          getPairNumber={getPairNumber}
          getMarkedState={getMarkedState}
          onAnswerClick={(answerId) => (!showMarked ? handleAnswerClick(answerId, 'left') : undefined)}
        />
        <MatchingColumn
          answers={columns[1] as AnswerQuestionMatchingAnswer[]}
          selectedAnswerId={selectedRight}
          column="right"
          isAnswerUsed={isAnswerUsed}
          getPairNumber={getPairNumber}
          getMarkedState={getMarkedState}
          onAnswerClick={(answerId) => (!showMarked ? handleAnswerClick(answerId, 'right') : undefined)}
        />
      </div>
      <QuestionMarkedMatching question={question} marked={marked} answer={exportedUserAnswer} showMarked={showMarked} showQuestion={true} />
    </QuestionBase>
  );
}
